import React from 'react';
import Carousel from 'react-bootstrap/Carousel';
import img1 from '../../images/homescreen/img-1.png';
import img2 from '../../images/homescreen/img-2.png';
import img3 from '../../images/homescreen/img-3.png';


const RoomsCarousel = () => {
  return (
    <Carousel style={{ "maxHeight": "500px" }}>
        <Carousel.Item>
            <img
                className="d-block w-100"
                src={img1}
                alt="First slide"
            />
            <Carousel.Caption>
                <h3>First slide label</h3>
                <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
            </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
            <img
                className="d-block w-100"
                src={img2}
                alt="Second slide"
            />
            <Carousel.Caption>
            <h3>Second slide label</h3>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
            </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
            <img
                className="d-block w-100"
                src={img3}
                alt="Third slide"
            />
            <Carousel.Caption>
                <h3>Third slide label</h3>
                <p>
                Praesent commodo cursus magna, vel scelerisque nisl consectetur.
                </p>
            </Carousel.Caption>
        </Carousel.Item>
    </Carousel>
  )
}

export default RoomsCarousel;